"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionalURLSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const copy_1 = require("./copy");
exports.optionalURLSchema = zod_1.default
    .string()
    .toLowerCase()
    .trim()
    .url({ message: copy_1.EMAILS_COPY.urlValidationErrorMsg })
    .optional()
    // becomes empty string when someone starts typing and then deletes it
    .or(zod_1.default.literal(''));
